import { render, staticRenderFns } from "./type121.vue?vue&type=template&id=d6435e04&scoped=true"
import script from "./type121.vue?vue&type=script&lang=js"
export * from "./type121.vue?vue&type=script&lang=js"
import style0 from "./type121.vue?vue&type=style&index=0&id=d6435e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6435e04",
  null
  
)

export default component.exports